import { IdibuSettingsPanel } from '@/modules/idibu';

/**
 * Job Board settings — surfaces the Idibu job-board integration. Non-job-board
 * integrations (Slack, etc.) live on the Integrations settings page. Same page
 * for everyone; Idibu's IDIBU_READ_ONLY demo flag globally disables mutations,
 * so Members see the panel but can't trigger Connect/Disconnect/Subscribe.
 */
export function JobBoardPage() {
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Job Board</h1>
        <p className="text-sm text-gray-500 mt-1">
          Connect external job boards and configure how listings sync.
        </p>
      </header>
      <IdibuSettingsPanel />
    </div>
  );
}
